/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.login', [])
    .factory('loginService', LoginService)
    .name;

/*@ngInject*/
function LoginService($rootScope, $http, $q) {
    return {activate, changePassword, login, resetPassword, sendResetPasswordLink};

    function login(user) {
        var deferred = $q.defer();
        var loginRequest = {
            username: user.name,
            password: user.password
        };
        $http.post('/api/auth/login', loginRequest).then(function success(response) {
            deferred.resolve(response);
        }, function fail(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    function sendResetPasswordLink(email) {
        var deferred = $q.defer();
        var url = '/api/noauth/resetPasswordByEmail?email=' + encodeURIComponent(email);
        $http.post(url, null).then(function success(response) {
            deferred.resolve(response);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function resetPassword(resetToken, password) {
        return $http.post('/api/noauth/resetPassword', {"password" : password}, {params: {resetToken}});
    }

    function activate(activateToken, password) {
        return $http.post('/api/noauth/activate', {"password": password}, {params: {activateToken}});
    }

    function changePassword(currentPassword, newPassword) {
        return $http.post('/api/auth/changePassword', {"currentPassword": currentPassword, "newPassword": newPassword});
    }
}



// WEBPACK FOOTER //
// ./src/app/api/login.service.js